export default __webpack_public_path__ + "static/media/Cellulitis-2.888f5bcd.jpg";